import React, { Fragment } from 'react';
import { SearchState } from 'react-instantsearch-core';
import { SearchState as CustomSearchState } from '../../admin-dashboard-tables/interfaces';

interface Props {
  attribute: string,
  instantRefinements: string[],
  searchState: CustomSearchState | SearchState,
  setSearchState: React.Dispatch<React.SetStateAction<CustomSearchState>>
    | React.Dispatch<React.SetStateAction<SearchState>>,
  onRemoveCallback?: () => void,
}

const CustomCurrentBreedRefinement = ({
  attribute,
  instantRefinements,
  searchState,
  setSearchState,
  onRemoveCallback,
}: Props) => {
  const { refinementList = {} } = searchState;
  if (instantRefinements.includes(attribute)
    && Array.isArray(refinementList[attribute])
    && refinementList[attribute].length > 0
  ) {
    return (
      <li className="ais-CurrentRefinements-item">
        <span className="ais-CurrentRefinements-label">
          Breed:
        </span>
        <span className="ais-CurrentRefinements-category">
          {refinementList[attribute].map((refinement) => (
            <Fragment key={refinement}>
              <span className="ais-CurrentRefinements-categoryLabel">
                {refinement}
              </span>
              <button
                className="ais-CurrentRefinements-delete"
                onClick={() => {
                  setSearchState((currentSearchState: CustomSearchState | SearchState) => {
                    const {
                      refinementList: currentRefinementList = {
                        [attribute]: [],
                      },
                    } = currentSearchState;
                    return {
                      ...currentSearchState,
                      refinementList: {
                        ...currentSearchState.refinementList,
                        [attribute]: currentRefinementList[attribute]
                          .filter((breed: string) => breed !== refinement),
                      },
                    };
                  });
                  if (onRemoveCallback) {
                    onRemoveCallback();
                  }
                }}
              >
                ✕
              </button>
            </Fragment>
          ))}
        </span>
      </li>
    );
  }
  return null;
};

export default CustomCurrentBreedRefinement;
